import { useSyncExternalStore } from "react";
import { getLanguage, getVersion, setLanguage, subscribe, t } from "./store.js";
import type { LanguageCode } from "./languages.js";

/**
 * Subscribe to the translation store and return t(). Components must obtain
 * t via this hook (not import it from store.ts) so they re-render when the
 * language changes.
 */
export function useT(): typeof t {
  useSyncExternalStore(subscribe, getVersion);
  return t;
}

/** Current language + switcher, re-rendering on change. `setLanguage`
 * resolves false if the catalog couldn't be fetched. */
export function useLanguage(): {
  language: LanguageCode;
  setLanguage: (code: LanguageCode) => Promise<boolean>;
} {
  useSyncExternalStore(subscribe, getVersion);
  return { language: getLanguage(), setLanguage };
}
